import {
  GenericErrorResponse,
} from './responses'

export const STRAPI_BASE_URL = process.env.NEXT_PUBLIC_STRAPI_API_URL || 'http://localhost:1337/api'
const options = {
  headers: {
    Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
  },
}

import { HttpClient, RequestParams } from './httpClient'
import { APIResponseCollection, APIResponse, ContentType } from 'src/types/content'

export class Content<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  getContentCollection
    = <K extends ContentType> (path: string, params: RequestParams = {}) =>
      this.request<APIResponseCollection<K>, GenericErrorResponse>({
        baseURL: '/api/content',
        path,
        method: 'GET',
        format: 'json',
        secure: true,
        ...params,
        ...options,
      })

  getContentSingle
    = <K extends ContentType> (path: string, params: RequestParams = {}) =>
      this.request<APIResponse<K>, GenericErrorResponse>({
        baseURL: '/api/content',
        path,
        method: 'GET',
        format: 'json',
        secure: true,
        ...params,
        ...options,
      })
}
